"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wsDataMapper = exports.WsFormatter = void 0;
const shared_1 = require("../types/binance/websockets/shared");
const spot_1 = require("../types/binance/websockets/spot");
const futures_1 = require("../utils/dataMappers/futures");
const futuresUsdm_1 = require("../utils/dataMappers/futuresUsdm");
const spot_2 = require("../utils/dataMappers/spot");
class WsFormatter {
    static format(messages) {
        // const
        return messages.reduce((acc, msg) => {
            const parsedEvent = (0, exports.wsDataMapper)(msg);
            return Object.assign(Object.assign({}, acc), { parsed: parsedEvent.parsed ? [...acc.parsed, parsedEvent.event] : acc.parsed, unparsed: !parsedEvent.parsed ? acc.unparsed : [...acc.unparsed, parsedEvent.event] });
        }, {
            source: messages,
            parsed: [],
            unparsed: [],
        });
    }
}
exports.WsFormatter = WsFormatter;
const wsDataMapper = (event) => {
    if (typeof event === 'object' && event !== null) {
        if (event.e && wsDataMap[event.e]) {
            return {
                event: wsDataMap[event.e](event),
                parsed: true,
            };
        }
    }
    return {
        event,
        parsed: false,
    };
};
exports.wsDataMapper = wsDataMapper;
const wsDataMap = {
    [spot_1.EWsBinanceSpotEventsTypes.executionReport]: spot_2.spotOrderUpdateRawToOrderUpdateMapper,
    [spot_1.EWsBinanceSpotEventsTypes.outboundAccountPosition]: spot_2.spotAccountUpdateRawToAccountUpdateMapper,
    [spot_1.EWsBinanceSpotMarketEventTypes.individualTicker]: spot_2.spotMarketIndividualTickerRawToIndividualTickerMapper,
    [shared_1.EWsBinanceFuturesEventTypes.ORDER_TRADE_UPDATE]: futuresUsdm_1.futuresUsdmOrderUpdateRawToOrderUpdateMapper,
    [shared_1.EWsBinanceFuturesEventTypes.ACCOUNT_UPDATE]: futures_1.futuresAccountUpdateRawToFuturesAccountUpdate,
    [shared_1.EWsBinanceFuturesMarketEventTypes.markPriceUpdate]: futures_1.futuresMarkPriceUpdateRawToFuturesMarkPriceUpdate,
};
